"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComponentPropTypes = exports.usePropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable react/forbid-foreign-prop-types */

/**
 * usePropTypes checks propTypes with React `prop-types` library and
 * return props merged with default props.
 * @param {object} propTypes - React propTypes object.
 * @param {object} defaultProps - React defaultProps object.
 * @param {object} props - Component props object.
 * @param {string} componentName - Component name string.
 * @param {string} location - PropTypes location eg. prop, context, child context.
 * @return {object} New props merged with default props.
 */


var usePropTypes = function usePropTypes(propTypes, defaultProps, props, componentName) {
  var location = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'prop';
  var newProps = Object.assign({}, defaultProps, props);

  _propTypes["default"].checkPropTypes(propTypes, newProps, location, componentName);

  return newProps;
};
/**
 * useComponentPropTypes checks propTypes with React `prop-types` library and
 * return props merged with default props.
 * @param {function} component - Component that you want to check propTypes. Set `component.propTypes`,
 * `component.defaultProps` for type checking, and `component.displayName` to overwrite `component.name` property.
 * @param {object} props - Component props object.
 * @param {string} location - PropTypes location eg. prop, context, child context.
 * @return {object} New props merged with default props.
 */


exports.usePropTypes = usePropTypes;

var useComponentPropTypes = function useComponentPropTypes(component, props) {
  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'prop';
  return usePropTypes(component.propTypes, component.defaultProps, props, component.displayName || component.name, location);
};

exports.useComponentPropTypes = useComponentPropTypes;